var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_designer)?_c('designer-orders'):_c('admin-orders')}
var staticRenderFns = []

export { render, staticRenderFns }